import api from "./api";
import Cookies from "js-cookie";

const getDocument = (id) => {
  return api.get(`documents/${id}`);
};

const getDocuments = (filters) => {
  return api.get("documents", { params: filters }).then((response) => {
    const { data } = response;
    return data;
  });
};

const getDocumentTypes = () => {
  return api.get("document-types");
};

const uploadDocument = (formData) => {
  return api.post("/documents/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const editDocument = (id, data) => {
  return api.put(`documents/${id}`, data).then((response) => {
    const { data: document } = response.data;
    return document;
  });
};

const addDocumentType = (type) => {
  return api.post("document-types", { name: type });
};

const processDocument = (id) => {
  return api.put(`documents/${id}/process`);
};

const deleteDocument = (id) => {
  return api.delete(`documents/${id}`, {
    headers: {
      "Content-Type": "application/json",
      withCredentials: true,
      "X-CSRF-TOKEN": Cookies.get("csrf_access_token"),
    },
  });
};

export default {
  getDocument,
  getDocuments,
  getDocumentTypes,
  uploadDocument,
  editDocument,
  addDocumentType,
  deleteDocument,
  processDocument,
};
